import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  max-width: 800px;
  margin: 6rem auto 4rem;
  padding: 2rem;
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 4px 15px rgba(122, 73, 136, 0.1);
`;

const Title = styled.h1`
  color: #7A4988;
  font-size: 2.4rem;
  margin-bottom: 1.5rem;
  text-align: center;
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const Subtitle = styled.h2`
  color: #7A4988;
  font-size: 1.6rem;
  margin-bottom: 1rem;
`;

const Text = styled.p`
  color: #555;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

function Shipping() {
  return (
    <PageContainer>
      <Title>Shipping Policy</Title>
      
      <Section>
        <Subtitle>Processing Time</Subtitle>
        <Text>
          All ready to ship orders are processed within 2-5 business days (excluding weekends and holidays) 
          after receiving your order confirmation email. You will receive another notification 
          when your order has shipped.
          ** Please note custom orders are not included in this processing time estimate.
        </Text>
      </Section>

      <Section>
        <Subtitle>Shipping Rates & Delivery</Subtitle>
        <Text>
          We offer flat rate shipping within the United States:
          - Standard Shipping (3-7 business days): $5.99
          - Expedited Shipping (2-3 business days): $12.99
        </Text>
        <Text>
          International shipping is available - rates are calculated at checkout based on 
          destination and weight. Delivery times vary by location (typically 7-21 business days).
        </Text>
      </Section>

      <Section>
        <Subtitle>Tracking Your Order</Subtitle>
        <Text>
          Once your order ships, you’ll receive a shipping confirmation email with a tracking 
          number. Please allow 24-48 hours for tracking information to update.
        </Text>
      </Section>

      <Section>
        <Subtitle>Lost or Delayed Shipments</Subtitle>
        <Text>
  If your order hasn’t arrived within the estimated delivery time, please contact us at{' '}
  <a href="mailto:lavenderandpalmco@gmail.com">lavenderandpalmco@gmail.com</a> with your order number, and we’ll investigate for you.
</Text>

      </Section>
    </PageContainer>
  );
}

export default Shipping;